/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { client } from "./api-client";

export const useGetReplenishmentRequests = (data: any) =>
  useQuery({
    queryKey: [
      "GetReplenishmentRequests",
      data?.pageNumber,
      data?.searchCriteria,
      data?.operationDate,
      data?.cashCenterId,
      data?.customerId,
      data?.sourceSPId,
      data?.isPrepack,
      data?.isBranchToATM,
    ],
    queryFn: ({ signal }) =>
      client(`machine/services/atm/open/requests`, { data, signal }),
  });

export const useAssignReplenishmentRoute = () => {
  const queryClient = useQueryClient();
  return useMutation<any>({
    mutationFn: (data: any) =>
      client(`machine/services/atm/assign/route`, {
        data,
        successMessage: "Route assigned successfully for selected job(s)!",
      }),
    onSuccess: () => {
      queryClient.resetQueries({
        queryKey: ["GetReplenishmentRequests"],
      });
    },
  });
};

export const useCancelReplenishmentService = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`machine/services/atm/cancel/services`, {
        data,
        successMessage: "Selected job(s) cancelled successfully!",
      }),
    onSuccess: () => {
      queryClient.resetQueries({ queryKey: ["GetReplenishmentRequests"] });
    },
  });
};

export const useCreateReplenishmentBulkOrders = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: any) =>
      client(`machine/services/atm/create/bulk/requests`, {
        data,
        successMessage: "Order(s) created successfully!",
      }),
    onSuccess: () => {
      queryClient.resetQueries({
        queryKey: ["GetReplenishmentRequests"],
      });
    },
  });
};

export const useCreateReplenishmentOpenOrders = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: any) =>
      client(`machine/services/atm/create/bulk/open/model`, {
        data,
        successMessage: "Order(s) created successfully!",
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["GetReplenishmentRequests"],
      });
    },
  });
};

export const useCreateReplenishmentRequest = () =>
  useMutation({
    mutationFn: (data: any) =>
      client(`machine/services/atm/create/request`, {
        data,
        successMessage: "Request submitted successfully!",
      }),
  });
export const useCreateMultiReplenishmentRequests = () =>
  useMutation({
    mutationFn: (data: any) =>
      client(`machine/services/atm/create/multiple/requests`, {
        data,
        successMessage: "Multiple requests submitted successfully!",
      }),
  });

export const useGetReplenishmentDetails = (data: any) =>
  useQuery<any>({
    queryKey: ["GetReplenishmentDetails", data?.requestId],
    queryFn: () =>
      client(`machine/services/atm/request/details/${data?.requestId}`),
    enabled: Boolean(data?.requestId),
  });

export const useEditReplenishmentJob = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`machine/services/atm/edit/request`, {
        data,
        successMessage: "Request edited successfully!",
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["GetReplenishmentDetails"] });
    },
  });
};

export const useUpdateReplenishmentStatus = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`machine/services/atm/update/request/status`, {
        data,
        successMessage: "Request status updated successfully!",
      }),
    onSuccess: () => {
      queryClient.resetQueries({ queryKey: ["GetReplenishmentDetails"] });
    },
  });
};

export const useGetAEDTemplate = () =>
  useMutation({
    mutationFn: (data: any) =>
      client(`machine/services/atm/download/atm/aed/template`, {
        data,
      }),
  });

export const useGetSmallDenominationsTemplate = () =>
  useMutation({
    mutationFn: (data: any) =>
      client(`machine/services/atm/download/denominations/template`, { data }),
  });

export const useAssignBagSeals = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`machine/services/atm/bulk/bags/assignment`, {
        data,
        successMessage: "Bag Seal Assigned successfully!",
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["GetReplenishmentRequests"] });
    },
  });
};

export const useAssignReplenishmentBags = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`machine/services/atm/assign/consignments`, { data }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["GetReplenishmentDetails"] });
    },
  });
};

export const useUpdateReplenishmentAfterCompletion = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`machine/services/atm/update/evhr/request`, {
        data,
        successMessage: "Request updated successfully!",
      }),
    onSuccess: () => {
      queryClient.resetQueries({ queryKey: ["GetReplenishmentDetails"] });
    },
  });
};

export const useValidateBulkBagsAssignment = () =>
  useMutation({
    mutationFn: (data: any) =>
      client(`machine/services/atm/validate/bulk/bags/assignment`, {
        data,
        errorMessage: "Invalid barcodes found.",
      }),
  });
